// extracted by mini-css-extract-plugin
export default {"root":"GglSx__root","messageWrapper":"SAStB__messageWrapper","frown":"osNV___frown"};